// sortingUtils.js

export function sortProviders(data, orderBy, sortOrder) {
  // Create a copy so we’re not mutating the original array
  const sorted = [...data];

  if (orderBy === "last_updated") {
    // Group by premium, then sort by last_updated
    sorted.sort((a, b) => {
      if (a.premium !== b.premium) {
        return a.premium === "1" ? -1 : 1;
      }
      const dateA = new Date(a.last_updated).getTime();
      const dateB = new Date(b.last_updated).getTime();
      return sortOrder === "asc" ? dateA - dateB : dateB - dateA;
    });
  } else if (orderBy === "premium") {
    // Sort purely by premium field
    // Asc: non-premium first, premium last
    // Desc: premium first, non-premium last
    sorted.sort((a, b) => {
      const premiumA = a.premium === "1" ? 1 : 0;
      const premiumB = b.premium === "1" ? 1 : 0;
      return sortOrder === "asc" ? premiumA - premiumB : premiumB - premiumA;
    });
  } else if (orderBy === "distance") {
    sorted.sort((a, b) => (sortOrder === "asc" ? a.distance - b.distance : b.distance - a.distance));
  } else if (orderBy === "name") {
    sorted.sort((a, b) => {
      const nameA = a.name.toLowerCase();
      const nameB = b.name.toLowerCase();
      if (nameA < nameB) return sortOrder === "asc" ? -1 : 1;
      if (nameA > nameB) return sortOrder === "asc" ? 1 : -1;
      return 0;
    });
  }

  return sorted;
}
